export default __webpack_public_path__ + "static/media/ChrisZiporyn.fda4d1c3.jpg";